import { createFileRoute } from '@tanstack/react-router';

import { routeMetadata } from '@/app/lib/tanstack-router';
import MembershipsPage from '@/settings/pages/memberships';

export const Route = createFileRoute('/settings/_layout/memberships/')({
  head: () => ({
    meta: routeMetadata('Memberships')
  }),
  component: MembershipsRoute,
  staticData: {
    headerSection: null
  }
});

function MembershipsRoute() {
  return <MembershipsPage/>;
}
